import { NormalizedLockedFeatures } from './lockedFeatures';
import { useTextOverlay } from './TextOverlayProvider';

/**
 * Returns the resolved locked-feature entry for the given feature key.
 *
 * Always returns a defined `{ disabled, tooltip? }` record — defaults to
 * `{ disabled: false }` when the caller didn't lock the feature, so consumers
 * can wire `disabled`/`tooltip` into UI props without any narrowing.
 */
export default function useLockedFeature<
  K extends keyof NormalizedLockedFeatures
>(feature: K): NormalizedLockedFeatures[K] {
  const { lockedFeatures } = useTextOverlay();
  return lockedFeatures[feature];
}
